import ChannelManager from '../../components/Channels/ChannelManager';

const ChannelsPage = () => {
  return <ChannelManager />;
};

export default ChannelsPage;
